import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../images/logo1.svg';
import { toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { getSupplier } from '../../redux/actions/Supplier/SupplierAction';

function SupplierSignIn({ supplier, history, getSupplier}){
    const location = useLocation();
    const redirectPath = location.state?.from || '/supplier/:supplierId';

    const [supplierPhoneNumber,setSupplierPhoneNumber]=useState('');
    const[password,setPassword]=useState('');

    useEffect(() => {
        console.log('location state', location.state);
        if (redirectPath !== '/supplier/:supplierId') {
            toast.error('Login to visit supplier pages!');
        }
    }, []);

    useEffect(()=>{
        console.log(supplier);
    },[supplier]);
    
    const handleLogin = (e) => {
        e.preventDefault();
        const user=JSON.parse(localStorage.getItem('suppliersList'));
        console.log('->'+user);
        let redirectPath;
        const getUser=user.filter((e)=>e.supplierPhoneNumber===supplierPhoneNumber)[0];
        console.log(getUser);
        if(getUser){
            getSupplier(getUser.id);
            if(getUser.password===password)
                redirectPath = location.state?.from || `/supplier/${getUser.id}`;
            else
                toast.error('Invalid Credentials');
        }
        console.log(getUser,password);
        console.log(redirectPath);
        localStorage.setItem('isLoggedIn', 'true');
        history.push({
            pathname: redirectPath
        });
    };

    return(
        <div>
            <section className="container-fluid maindiv mt-5">
                <div className="container formdiv my-5 d-flex shadow">
                    <img src={logo} className="formimg"></img>
                    <form className="myform mt-4" onSubmit={handleLogin}>
                        <div className="form-group mt-2">
                            <label htmlFor="+91 1234567890">Phone Number</label>
                            <input value={supplierPhoneNumber} onChange={(e) => setSupplierPhoneNumber( e.target.value )} type="number" className="form-control" id="+91 1234567890" required />
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="examplePassword">Password</label>
                            <input value={password} onChange={(e) => setPassword(e.target.value )} type="password" className="form-control" id="examplePassword" required />
                        </div>
                        <br></br>
                        <button type="submit" className="btn btn-primary">Submit</button>
                        <p className="mt-3">First time here?<span><Link to="/supplier/signup"> Create Account </Link></span></p>
                    </form>
                </div>
            </section>
            <ToastContainer />
        </div>
    );
}

const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        supplier: state.suppliers,
    };
};

const mapDispatchToProps = {
    getSupplier,
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSignIn);